export const TABLE_HEADERS = Object.freeze([
	'No.',
	'Name',
	'Phone Number',
	'Order Status',
	'Shipping Status',
	'Last Status Change',
	'1st Call Result',
	'1st Call Date',
	'2nd Call Result',
	'2nd Call Date',
	'Add Call',
]);
